import { useParams } from 'react-router-dom'

import { useGetActionTypeQuery } from '../services/actionType'

export function useActionType() {
  const { id: actionTypeId } = useParams()

  const isNewActionType = !actionTypeId

  const { data: actionType } = useGetActionTypeQuery({ actionTypeId })

  return {
    actionType,
    actionTypeId,
    isNewActionType,
    formId: actionType?.formId
  }
}
